export default __webpack_public_path__ + "static/illustration-552264d1ddc7fae706d9bd926563a236.png";